import { ServiceData } from '@/types';

import articles from './PILATES_ARTICLES_SI.json';
import exercises from './PILATES_EXERCISES_SI.json';
import recipes from './PILATES_RECIPES_SI.json';

export const PILATES_DATA_SI: ServiceData = {
  articles,
  exercises,
  recipes,
};
